'use client';

import { useTranslations } from 'next-intl';
import { AnimatedButton } from '@/components/ui/animated-button';
import { Icon } from '@/components/ui/icon';
import { PlusSignIcon } from '@/components/ui/icon/glyphs';
import { useIntentRoutePrefetch } from '@/hooks/use-intent-route-prefetch';
import { NetworkLink } from '@/i18n/network-link';

const PROPOSAL_HREF = '/proposals?create=1';

export function StartDebateLink(): React.ReactNode {
  const t = useTranslations('markets');
  const proposalIntent = useIntentRoutePrefetch(PROPOSAL_HREF);

  return (
    <AnimatedButton variant="secondary" size="default" prefix={PlusSignIcon} asChild>
      <NetworkLink href={PROPOSAL_HREF} prefetch={false} {...proposalIntent}>
        <Icon icon={PlusSignIcon} className="size-4 shrink-0" aria-hidden />
        {t('sparse.cta')}
      </NetworkLink>
    </AnimatedButton>
  );
}
